// assets/size-chart-data.js

window.DripSizeGuides = {
  "Default": {
    IN: [
      { size: 'One Size', chest: '-', shoulder: '-', length: '-' }
    ],
    CM: [
      { size: 'One Size', chest: '-', shoulder: '-', length: '-' }
    ]
  },    
  
  "Oversized Tees": {
    name: "Tees Size Chart",

    IN: [
      { size: "XS", chest: "39", shoulder: "20", length: "26.5" },
      { size: "S",  chest: "42", shoulder: "21.5", length: "27.5" },
      { size: "M",  chest: "44", shoulder: "22", length: "28.5" },
      { size: "L",  chest: "46", shoulder: "22.5", length: "29.5" },
      { size: "XL", chest: "49", shoulder: "23.5", length: "30" },
      { size: "XXL", chest: "52", shoulder: "25.5", length: "31.5" }
    ],

    CM: [
      { size: "XS", chest: "99.1", shoulder: "50.8", length: "67.3" },
      { size: "S",  chest: "106.7", shoulder: "54.6", length: "69.9" },
      { size: "M",  chest: "111.8", shoulder: "55.9", length: "72.4" },
      { size: "L",  chest: "116.8", shoulder: "57.2", length: "74.9" },
      { size: "XL", chest: "124.5", shoulder: "59.7", length: "76.2" },
      { size: "XXL", chest: "132.1", shoulder: "64.8", length: "80.0" }
    ]
  },


  "Vest": {
    name: "Vest Size Chart",

    IN: [
      { size: "XS", chest: "39", shoulder: "20", length: "27" },
      { size: "S",  chest: "42", shoulder: "21.5", length: "27.5" },
      { size: "M",  chest: "44", shoulder: "22", length: "28" },
      { size: "L",  chest: "46", shoulder: "22.5", length: "28.5" },
      { size: "XL", chest: "49", shoulder: "23.5", length: "29" },
      { size: "XXL", chest: "52", shoulder: "25.5", length: "29.5" }
    ],

    CM: [
      { size: "XS", chest: "99.1", shoulder: "50.8", length: "68.6" },
      { size: "S",  chest: "106.7", shoulder: "54.6", length: "69.9" },
      { size: "M",  chest: "111.8", shoulder: "55.9", length: "71.1" },
      { size: "L",  chest: "116.8", shoulder: "57.2", length: "72.4" },
      { size: "XL", chest: "124.5", shoulder: "59.7", length: "73.7" },
      { size: "XXL", chest: "132.1", shoulder: "64.8", length: "74.9" }
    ]
  },
"cropped raglan": {
  name: "Tees Size Chart",

  IN: [
    { size: "XS", chest: "39", shoulder: "20", length: "25.5" },
    { size: "S",  chest: "42", shoulder: "21.5", length: "26" },
    { size: "M",  chest: "44", shoulder: "22", length: "26.5" },
    { size: "L",  chest: "46", shoulder: "22.5", length: "27" },
    { size: "XL", chest: "49", shoulder: "23.5", length: "27.5" },
    { size: "XXL", chest: "52", shoulder: "25.5", length: "27.5" }
  ],

  CM: [
    { size: "XS", chest: "99.1", shoulder: "50.8", length: "64.8" },
    { size: "S",  chest: "106.7", shoulder: "54.6", length: "66.0" },
    { size: "M",  chest: "111.8", shoulder: "55.9", length: "67.3" },
    { size: "L",  chest: "116.8", shoulder: "57.2", length: "68.6" },
    { size: "XL", chest: "124.5", shoulder: "59.7", length: "69.9" },
    { size: "XXL", chest: "132.1", shoulder: "64.8", length: "69.9" }
  ]
},
"cropped ringer": {
  name: "Tees Size Chart",

  IN: [
    { size: "XS", chest: "39", shoulder: "20", length: "25.5", sleeve: "5.8" },
    { size: "S",  chest: "42", shoulder: "21.5", length: "26", sleeve: "6" },
    { size: "M",  chest: "44", shoulder: "22", length: "26.2", sleeve: "6.2" },
    { size: "L",  chest: "46", shoulder: "22.5", length: "26.5", sleeve: "6.5" },
    { size: "XL", chest: "49", shoulder: "23.5", length: "26.7", sleeve: "6.7" }
  ],

  CM: [
    { size: "XS", chest: "99.1", shoulder: "50.8", length: "64.8", sleeve: "14.7" },
    { size: "S",  chest: "106.7", shoulder: "54.6", length: "66.0", sleeve: "15.2" },
    { size: "M",  chest: "111.8", shoulder: "55.9", length: "66.5", sleeve: "15.7" },
    { size: "L",  chest: "116.8", shoulder: "57.2", length: "67.3", sleeve: "16.5" },
    { size: "XL", chest: "124.5", shoulder: "59.7", length: "67.8", sleeve: "17.0" }
  ]
},
"Bottoms": {
  name: "Bottoms Size Chart",

  IN: [
    { size: "XS", waist: "26-28", length: "40" },
    { size: "S",  waist: "28-30", length: "40.5" },
    { size: "M",  waist: "30-32", length: "41" },
    { size: "L",  waist: "32-34", length: "41.5" },
    { size: "XL", waist: "34-36", length: "42" },
    { size: "XXL", waist: "36-38", length: "42.7" },
    { size: "XXXL", waist: "38-40", length: "42.7" }
  ],

  CM: [
    { size: "XS", waist: "66.0-71.1", length: "101.6" },
    { size: "S",  waist: "71.1-76.2", length: "102.9" },
    { size: "M",  waist: "76.2-81.3", length: "104.1" },
    { size: "L",  waist: "81.3-86.4", length: "105.4" },
    { size: "XL", waist: "86.4-91.4", length: "106.7" },
    { size: "XXL", waist: "91.4-96.5", length: "108.5" },
    { size: "XXXL", waist: "96.5-101.6", length: "108.5" }
  ]
},
"Hoodies": {
  name: "Hoodie Size Chart",

  IN: [
    { size: "XS", chest: "44", shoulder: "19", length: "27" },
    { size: "S",  chest: "46", shoulder: "20", length: "28" },
    { size: "M",  chest: "48", shoulder: "21", length: "29" },
    { size: "L",  chest: "50", shoulder: "22", length: "30" },
    { size: "XL", chest: "52", shoulder: "23", length: "31" },
    { size: "XXL", chest: "54", shoulder: "24", length: "32" }
  ],

  CM: [
    { size: "XS", chest: "111.8", shoulder: "48.3", length: "68.6" },
    { size: "S",  chest: "116.8", shoulder: "50.8", length: "71.1" },
    { size: "M",  chest: "121.9", shoulder: "53.3", length: "73.7" },
    { size: "L",  chest: "127.0", shoulder: "55.9", length: "76.2" },
    { size: "XL", chest: "132.1", shoulder: "58.4", length: "78.7" },
    { size: "XXL", chest: "137.2", shoulder: "61.0", length: "81.3" }
  ]
},

"Henley": {
  name: "Henley Size Chart",

  IN: [
    { size: "XS", chest: "34-36", shoulder: "15", length: "25.5", sleeve: "24" },
    { size: "S",  chest: "36-38", shoulder: "15.5", length: "26.5", sleeve: "24.5" },
    { size: "M",  chest: "38-40", shoulder: "16", length: "27.5", sleeve: "25" },
    { size: "L",  chest: "40-42", shoulder: "16.5", length: "28.5", sleeve: "25.5" },
    { size: "XL", chest: "42-44", shoulder: "17", length: "29.5", sleeve: "26" }
  ],

  CM: [
    { size: "XS", chest: "86.4-91.4", shoulder: "38.1", length: "64.8", sleeve: "61.0" },
    { size: "S",  chest: "91.4-96.5", shoulder: "39.4", length: "67.3", sleeve: "62.2" },
    { size: "M",  chest: "96.5-101.6", shoulder: "40.6", length: "69.9", sleeve: "63.5" },
    { size: "L",  chest: "101.6-106.7", shoulder: "41.9", length: "72.4", sleeve: "64.8" },
    { size: "XL", chest: "106.7-111.8", shoulder: "43.2", length: "74.9", sleeve: "66.0" }
  ]
},
"waffle knit": {
  name: "Tees Size Chart",

  IN: [
    { size: "XS", chest: "39", shoulder: "20", length: "26.5" },
    { size: "S",  chest: "42", shoulder: "21.5", length: "27.5" },
    { size: "M",  chest: "44", shoulder: "22", length: "28.5" },
    { size: "L",  chest: "46", shoulder: "22.5", length: "29.5" },
    { size: "XL", chest: "49", shoulder: "23.5", length: "30" },
    { size: "XXL", chest: "52", shoulder: "25.5", length: "31.5" }
  ],

  CM: [
    { size: "XS", chest: "99.1", shoulder: "50.8", length: "67.3" },
    { size: "S",  chest: "106.7", shoulder: "54.6", length: "69.9" },
    { size: "M",  chest: "111.8", shoulder: "55.9", length: "72.4" },
    { size: "L",  chest: "116.8", shoulder: "57.2", length: "74.9" },
    { size: "XL", chest: "124.5", shoulder: "59.7", length: "76.2" },
    { size: "XXL", chest: "132.1", shoulder: "64.8", length: "80.0" }
  ]
},
"Polo": {
  name: "Polo Size Chart",

  IN: [
    { size: "S", chest: "36", brandSize: "Small", shoulder: "16", length: "25", sleeve: "7.5" },
    { size: "M", chest: "38", brandSize: "Medium", shoulder: "17", length: "26", sleeve: "8" },
    { size: "L", chest: "40", brandSize: "Large", shoulder: "18", length: "27", sleeve: "8.25" },
    { size: "XL", chest: "42", brandSize: "X_Large", shoulder: "19", length: "28", sleeve: "8.5" }
  ],

  CM: [
    { size: "S", chest: "91.4", brandSize: "Small", shoulder: "40.6", length: "63.5", sleeve: "19.1" },
    { size: "M", chest: "96.5", brandSize: "Medium", shoulder: "43.2", length: "66.0", sleeve: "20.3" },
    { size: "L", chest: "101.6", brandSize: "Large", shoulder: "45.7", length: "68.6", sleeve: "21.0" },
    { size: "XL", chest: "106.7", brandSize: "X_Large", shoulder: "48.3", length: "71.1", sleeve: "21.6" }
  ]
},
"DRIP ATHLETIC": {
  name: "Drip Athletic Size Chart",

  IN: [
    { size: "S", chest: "38", shoulder: "16.5", length: "26", sleeve: "7.5" },
    { size: "M", chest: "40", shoulder: "17", length: "27", sleeve: "8" },
    { size: "L", chest: "42", shoulder: "17.5", length: "28", sleeve: "8.5" },
    { size: "XL", chest: "44", shoulder: "18", length: "28", sleeve: "8.5" }
  ],

  CM: [
    { size: "S", chest: "96.5", shoulder: "41.9", length: "66.0", sleeve: "19.1" },
    { size: "M", chest: "101.6", shoulder: "43.2", length: "68.6", sleeve: "20.3" },
    { size: "L", chest: "106.7", shoulder: "44.5", length: "71.1", sleeve: "21.6" },
    { size: "XL", chest: "111.8", shoulder: "45.7", length: "71.1", sleeve: "21.6" }
  ]
},
};